import { css, unsafeCSS } from 'lit-element';

/**
 * Convert px => rem
 *
 * @param {number} sizeInPx
 * @param {number} [base=14]
 */
export const pxToRem = (sizeInPx, base = 14) => unsafeCSS(`${sizeInPx / base}rem`);

/**
 * Accept hover styles only if device support hover actions
 *
 * (min-width: 1024px) - currently, mobile chrome doesn't support correctly hover detection. this will exlude mobile screens
 * (min-width: 0\0) - old chrome, ie11 and other necros
 * (min--moz-device-pixel-ratio: 0) - firefox
 *
 * @param styles
 * @returns {CSSResult}
 */
export const useHover = styles => css`
  @media (hover: hover) and (min-width: 1024px),
    (min-width: 0\\0),
    (min--moz-device-pixel-ratio: 0) {
    ${styles}
  }
`;
